// extracted by mini-css-extract-plugin
module.exports = {"root":"N_bY","error":"N_x"};